import { graphql, HttpResponse } from 'msw'
import { type EnrollmentMultiFundingData, type EnrollmentMultiFundingSubmitOutput } from '../../../../models'

export const getEnrollmentMultiFundingDataMock: EnrollmentMultiFundingData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/funding',
  enrollmentData: {
    applicationId: '305802305',
    transferFundsInitiated: true,
  },
  complete: true,
}

export const submitEnrollmentMultiFundingDataMock: EnrollmentMultiFundingSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/create-passkey',
  complete: true,
}

export const mockGetEnrollmentMultiFundingData = graphql.mutation('getEnrollmentMultiFundingData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiFundingDataMock } })
})

export const mockSubmitEnrollmentMultiFundingData = graphql.mutation('submitEnrollmentMultiFundingData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiFundingDataMock } })
})

export const mockEnrollmentMultiFunding = [mockGetEnrollmentMultiFundingData, mockSubmitEnrollmentMultiFundingData]
